import React, { useEffect, useState } from "react";
import './Paginate.module.css';

const AdminPagination = ({ dataPerPage, totalData, onPageChange, currentPage: controlledPage, showRange = true, previousLabel = "Previous", nextLabel = "Next", paginationClassName }) => {
    const [internalPage, setInternalPage] = useState(controlledPage ?? 1);
    const totalPages = Math.ceil(totalData / dataPerPage);

    useEffect(() => {
        if (controlledPage != null) {
            setInternalPage(controlledPage);
        }
    }, [controlledPage]);

    const currentPage = controlledPage ?? internalPage;

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            if (controlledPage == null) {
                setInternalPage(pageNumber);
            }
            if (onPageChange) {
                onPageChange(pageNumber);
            }
        }
    };

    const indexOfLastData = currentPage * dataPerPage;
    const indexOfFirstData = indexOfLastData - dataPerPage;

    const rangeStart = totalData === 0 ? 0 : indexOfFirstData + 1;
    const rangeEnd = indexOfLastData < totalData ? indexOfLastData : totalData;

    return (
        <div className={`showing-main admin-org-pagination d-flex mt-2 mb-5 align-items-center ${paginationClassName || ''} ${!showRange ? 'admin-org-pagination-centered' : 'justify-content-between'}`}>
            {showRange && (
            <div className="showing-para">
                <p>Showing {rangeStart} to {rangeEnd} of {totalData} entries</p>
            </div>
            )}
            <div className={`pagination-buttons d-flex admin-org-pagination-buttons ${!showRange ? 'admin-org-pagination-inner' : ''}`}>
                <button
                    type="button"
                    className="admin-org-pagination-prev previous-btn previous-pagenisation"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    {previousLabel}
                </button>

                {[...Array(totalPages).keys()].map((index) => {
                    const page = index + 1;
                    return (
                        <button
                            key={page}
                            type="button"
                            className={`admin-org-page-num ${currentPage === page ? 'admin-org-page-active' : ''}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </button>
                    );
                })}

                <button
                    type="button"
                    className="admin-org-pagination-next previous-btn previous-pagenisation"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    {nextLabel}
                </button>
            </div>
        </div>
    );
}

export default AdminPagination;
